import { ApplicationView, useController } from '@aha-app/mvc';
import classNames from 'classnames';
import React from 'react';
import customElementBoolAttr from '../../../utils/customElementBoolAttr';
import { VotingSessionType } from '../../../widgets/VotingSessionType';
import VotingSessionController from './controllers/VotingSessionController';
import styles from './VotingSession.module.css';
import pokerIcon from '../../../assets/icons/votingTypePoker.svg';
import fistToFiveIcon from '../../../assets/icons/votingTypeFistToFive.svg';
import standardVotingIcon from '../../../assets/icons/votingTypeStandard.svg';
import { svgToIcon } from '../../../utils/svg';

const largeIconWidth = 17;
const smallIconWidth = 14;

export const VotingSessionTypeData: Record<
  VotingSessionType,
  { iconLarge: JSX.Element; iconSmall: JSX.Element; name: string }
> = {
  [VotingSessionType.Standard]: {
    iconLarge: svgToIcon(standardVotingIcon, { width: largeIconWidth }),
    iconSmall: svgToIcon(standardVotingIcon, { width: smallIconWidth }),
    name: 'Standard',
  },
  [VotingSessionType.FistToFive]: {
    iconLarge: svgToIcon(fistToFiveIcon, { width: largeIconWidth }),
    iconSmall: svgToIcon(fistToFiveIcon, { width: smallIconWidth }),
    name: 'Fist to five',
  },
  [VotingSessionType.Poker]: {
    iconLarge: svgToIcon(pokerIcon, { width: largeIconWidth }),
    iconSmall: svgToIcon(pokerIcon, { width: smallIconWidth }),
    name: 'Planning poker',
  },
} as const;

export const VotingSessionNameAndIcon = ({
  sessionType,
  size,
}: {
  sessionType: VotingSessionType;
  size: 'large' | 'small';
}) => {
  const { name, iconLarge, iconSmall } = VotingSessionTypeData[sessionType];
  return (
    <div className='flex tw-items-center'>
      {size === 'large' ? iconLarge : iconSmall}
      <span className='ml-2'>{name}</span>
    </div>
  );
};

export const VotingSetupSessionTypeControls = ApplicationView(() => {
  const controller = useController(VotingSessionController);
  const { sessionType: currentSessionType } = controller.state;

  const sessionTypeOptions = [
    VotingSessionType.Standard,
    VotingSessionType.FistToFive,
    VotingSessionType.Poker,
  ];

  return (
    <div className={styles.optionToggleInput}>
      <p className='m-0 color-secondary'>Voting type</p>
      <aha-menu>
        <span
          slot='control'
          className={classNames('t-150', styles.menuTrigger)}
        >
          <VotingSessionNameAndIcon
            sessionType={currentSessionType}
            size='large'
          />
          <aha-icon class='ml-2' icon='fa-solid fa-chevron-down' />
        </span>
        <aha-menu-content>
          {sessionTypeOptions.map(sessionType => {
            return (
              <aha-menu-item
                key={sessionType}
                selected={customElementBoolAttr(
                  currentSessionType === sessionType
                )}
                onClick={() => controller.actionSetSessionType(sessionType)}
              >
                <div className='my-2 pl-2'>
                  <VotingSessionNameAndIcon
                    sessionType={sessionType}
                    size='large'
                  />
                </div>
              </aha-menu-item>
            );
          })}
        </aha-menu-content>
      </aha-menu>
    </div>
  );
});
